import { OfferingSummaryHeader } from 'components/business/receipts/OfferingSummary/OfferingSummaryHeader';
import { consumer, core } from '@tock/coretypes';
import { layoutSpacing } from 'components/business/receipts/OfferingSummary/receiptOfferingSummaryCssDefs';
import React from 'react';
import ReceiptActionButtons from 'components/business/receipts/ReceiptActionButtons';

interface ReceiptOfferingSummaryProps {
  business: consumer.IBusinessConfig;
  isAuthenticated: boolean;
  purchase: core.PastPurchase;
  fetchData: () => unknown;
  cancellationPolicy: React.ReactNode;
}

export const ReceiptOfferingSummary: React.FC<ReceiptOfferingSummaryProps> = ({
  business,
  isAuthenticated,
  purchase,
  fetchData,
  cancellationPolicy,
}) => {
  return (
    <div css={layoutSpacing}>
      <OfferingSummaryHeader
        business={business}
        isInteractive
        isAuthenticated={isAuthenticated}
        purchase={purchase}
      />
      <ReceiptActionButtons
        business={business}
        purchase={purchase}
        fetchData={fetchData}
        isAuthenticated={isAuthenticated}
      />
      {cancellationPolicy}
    </div>
  );
};
